import React, { Component } from 'react';

class About extends Component {
   render() {

      if (this.props.data) {
         var profilepic = "images/" + this.props.data.image;
      }

      return (
         <section id="about">
            <div className="row">
               <div className="three columns">
                  <img className="profile-pic" src={profilepic} alt="Elisabe Monteiro" />
               </div>
               <div className="nine columns main-col">
                  <h2>About me</h2>

                  <p>I am Brazilian, a post-graduated teacher and lawyer.
                  Since graduating in Modern Languages - Portuguese / English and correlated literatures, I have acquired extensive experience in the teaching field in all age groups of regular education, pre-university entrance exams and foreign language institutes, as well as in private lessons of English and Portuguese for foreigners  both for  teenagers and adults. I am a passionate communicator and avid learner.</p>
                  <p><h2>Languages:</h2>
                     Portuguese:  Qualified native teacher
                  <br />English: Fluent (Cambridge CPE)
                  <br />Spanish: Advanced
                  <br />French: Basic</p>
               </div>
            </div>

         </section>
      );
   }
}

export default About;



// WEBPACK FOOTER //
// ./src/Components/About.js